import axios from 'axios';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { FaRegCalendarAlt } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const QuoteCard = ({ quote }) => {
  console.log("quote", quote);

  return (
    <React.Fragment>
      <figure className='py-3'>
        <div className='space-y-2'>
          <h1 className='font-semibold text-base'>#SQ-{quote.id}</h1>
          <p className='flex items-center space-x-1 text-sm font-semibold'>{quote.summary}</p>
          <p className='flex items-center space-x-1 text-sm'>{quote.description}</p>
          <p className='flex items-center space-x-1 text-sm'>Service:- {quote.service.name}</p>
          <p className='flex items-center space-x-1 text-sm'><FaRegCalendarAlt size={12} /><span>{moment(quote.created_at).format('Do MMMM YYYY')}</span></p>
          <p className='flex items-center space-x-1 text-sm'><FiMapPin size={12} /><span>{quote.city} - {quote.postal_code}, {quote.state}</span></p>
          {/* <span className='flex items-center space-x-2'>
            <p className='flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit'>
              {quote.work_status === "NEW_WORK" && <span className='bg-green-600 px-2 py-1 text-white rounded text-xs'> {quote.work_status.replace('_', ' ').toLowerCase()}</span>}
              {quote.work_status === "EXISTING_WORK" && <span className='bg-red-600 px-2 py-1 text-white rounded text-xs'> {quote.work_status.replace('_', ' ').toLowerCase()}</span>}
              {quote.work_status === "HALF_DONE" && <span className='bg-red-600 px-2 py-1 text-white rounded text-xs'> {quote.work_status.replace('_', ' ').toLowerCase()}</span>}
            </p>
            <p className='flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit'>
              {quote.status === "QUOTED" && <span className='bg-green-600 px-2 py-1 text-white rounded text-xs'> {quote.status.replace('_', ' ').toLowerCase()}</span>}
              {quote.status === "BID_CLOSED" && <span className='bg-red-600 px-2 py-1 text-white rounded text-xs'> {quote.status.replace('_', ' ').toLowerCase()}</span>}
            </p>
          </span> */}
          <span className='flex items-center space-x-2'>
            <p className='flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit'>
              {quote.work_status === "NEW_WORK" && (
                <span className='bg-green-600 px-2 py-1 text-white rounded text-xs'>
                  {quote.work_status.replace('_', ' ').toLowerCase()}
                </span>
              )}
              {quote.work_status === "EXISTING_WORK" && (
                <span className='bg-yellow-600 px-2 py-1 text-white rounded text-xs'>
                  {quote.work_status.replace('_', ' ').toLowerCase()}
                </span>
              )}
              {quote.work_status === "HALF_DONE" && (
                <span className='bg-orange-600 px-2 py-1 text-white rounded text-xs'>
                  {quote.work_status.replace('_', ' ').toLowerCase()}
                </span>
              )}
            </p>
            <p className='flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit'>
              {quote.status === "QUOTED" && (
                <span className='bg-blue-600 px-2 py-1 text-white rounded text-xs'>
                  {quote.status.replace('_', ' ').toLowerCase()}
                </span>
              )}
              {/* {quote.status === "BID_CLOSED" && (
                <span className='bg-red-600 px-2 py-1 text-white rounded text-xs'>
                  {quote.status.replace('_', ' ').toLowerCase()}
                </span>
              )} */}
            </p>
          </span>
          <div className='pt-2'>
            <Link to={`/dashboard/quote/${quote.uuid}`} className='btn-primary-sm'>View Quote Details</Link>
          </div>
        </div>
      </figure>
    </React.Fragment>
  )
}

const PaymentCard = ({ booking }) => {
  return (
    <React.Fragment>
      <figure className='py-3'>
        <div className='space-y-2'>
          <h1 className='font-semibold text-base'>{booking.service_quote.service.name}</h1>
          <p className='flex items-center space-x-1 text-sm'><FaRegCalendarAlt size={12} /><span>{moment(booking.service_quote.created_at).format('Do MMMM YYYY')}</span></p>
          <p className='flex items-center space-x-1 text-sm'><FiMapPin size={12} /><span>{booking.service_quote.city} - {booking.service_quote.postal_code}, {booking.service_quote.state}</span></p>
          <p className='flex items-center space-x-1 text-xs capitalize rounded-sm overflow-clip w-fit'>
            {booking.status && <span className='bg-red-600 px-2 py-1 text-white rounded text-xs'> {booking.status.replace('_', ' ').toLowerCase()}</span>}
          </p>
          <div className='pt-2'>
            <Link to={`/dashboard/booking/${booking.uuid}`} className='btn-primary-sm'>View Booking Details</Link>
          </div>
        </div>
      </figure>
    </React.Fragment>
  )
}

const Quote = () => {

  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pending_bookings, setPending_bookings] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/service-quote`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
        }
      });
      if (response.data.status) {
        setQuotes(response.data.data.quotes);
        setPending_bookings(response.data.data.pending_bookings);
      }
      else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('An error occured');
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <figure className='border shadow-lg relative'>
        <div className='px-5 py-4 space-y-1 border-b'>
          <h1 className='text-base font-medium'>My Quotes</h1>
          <p className='text-xs text-gray-500'>Check your previous quotes</p>
        </div>
        <div className='p-5 pt-1 space-y-3 divide-y quotes-container' style={{ maxHeight: '500px', overflowY: 'auto' }}>
          {loading ? (
            <div
              style={{
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="spinner"></div>
            </div>
          ) : quotes.length === 0 && pending_bookings.length === 0 ? (
            <div className='text-center text-sm text-gray-500 py-10'>No data found</div>
          ) : (
            <>
              {/* {quotes.map(quote => (
                <QuoteCard key={quote.id} quote={quote} />
              ))} */}
              {quotes
                .filter(quote => quote.status !== "BID_CLOSED")
                .map(quote => (
                  <QuoteCard key={quote.id} quote={quote} />
                ))}
              {pending_bookings.map(booking => (
                <PaymentCard key={booking.id} booking={booking} />
              ))}
            </>
          )}
        </div>
      </figure>
    </React.Fragment >
  )
}

export default Quote;